<script>
  import {
    integrationStore,
    activeProviderConfigStore,
    providerConfigDraftStore,
  } from "../../../stores";

  export let provider;

  const loadConfigDefaults = () => {
    const activeConfig = $activeProviderConfigStore;

    if (!$providerConfigDraftStore.dataRefresh) {
      const defaultEnabled = activeConfig.dataRefresh?.enabled ?? false;
      const defaultSyncAs = activeConfig.dataRefresh?.syncAs || [];

      $integrationStore.setValue("enabled", defaultEnabled, "dataRefresh");
      $integrationStore.setValue("syncAs", defaultSyncAs, "dataRefresh");
    }
  };

  $: if (provider) {
    loadConfigDefaults();
  }
</script>
